import { format } from 'date-fns';
import { getDuration } from '../../../../shared/utils';
import {
  FormattedReportItemDTO,
  LocationReportStatus,
  VisitedLocationsFilters,
  VisitedLocationsFiltersState,
  TransportVisitedLocationsReportItemDTO,
} from '../types';
import { SortDirection } from '../../../../shared/utils/constants';
import { getTimezone } from '../../../../global/utils';
import { formatReportPayloadDate } from '../../../utils/helpers';

export const formatLocationReportItem = (
  locationReport: TransportVisitedLocationsReportItemDTO,
): FormattedReportItemDTO[] => {
  const { visits, ...reportBase } = locationReport;

  if (visits.length) {
    return visits.map((visit) => ({
      ...reportBase,
      id: crypto.randomUUID(),
      locationId: reportBase.id,
      arriveTime: visit.arriveTime,
      arriveTimeFormatted: format(
        new Date(visit.arriveTime),
        'HH:mm dd/MM/yyyy',
      ),
      duration: visit.duration,
      durationFormmated: getDuration(visit.duration),
    }));
  }

  return [
    {
      ...reportBase,
      id: crypto.randomUUID(),
      locationId: reportBase.id,
      arriveTime: null,
      arriveTimeFormatted: null,
      duration: null,
      durationFormmated: null,
    },
  ];
};

export const sortReportByStatus = (
  data: FormattedReportItemDTO[],
  sortDirection: SortDirection,
) => {
  return data.slice().sort((a, b) => {
    const statusOrder: Record<LocationReportStatus, number> = {
      VISITED: 1,
      NOT_VISITED: 2,
    };

    const statusA = a.status as LocationReportStatus;
    const statusB = b.status as LocationReportStatus;

    return sortDirection === SortDirection.ASC
      ? statusOrder[statusA] - statusOrder[statusB]
      : statusOrder[statusB] - statusOrder[statusA];
  });
};

export const formatLocationReportPayload = (
  filters: VisitedLocationsFiltersState,
): VisitedLocationsFilters => {
  return {
    transports: filters.transports,
    locations: filters.locations,
    groups: filters.groups,
    radius: filters.radius,
    duration: filters.stopPeriod * 60, // convert minutes to seconds
    start: formatReportPayloadDate(filters.start), // convert to UTC
    end: formatReportPayloadDate(filters.end), // convert to UTC
    tz: getTimezone(),
  };
};
